import React from "react";

import { Link } from "react-router-dom";
const heroImage = "/Images/SolutionHero.jpg";

const solutions = [
  {
    title: "Field Research & Monitoring",
    text: "We run long-term population studies across 22 countries in Africa. The data we generate is what conservation plans, court cases, and government policies are built on.",
    points: [
      "Satellite tracking of migratory species",
      "Nest success monitoring at hundreds of sitesannually",
      "Data-sharing with IUCN and BirdLife International"
    ]
  },
  {
    title: "Community Partnership",
    text: "Conservation that ignores local communities doesn't work.convservationists spent years building trustwith farmers and rural land owners — because they determine whether these species survive.",
    points: [
      "Training community rangers as wildlife monitors",
      "Farmer workshops on coexistence with large birds",
      "Economic incentive programs for habitat protection"
    ]
  },
  {
    title: "Habitat Restoration",
    text: "convservationist don't just protect what remains — they actively restore what's been lost. This means replanting riparian forests, restoring wetland hydrology, and installing nest boxes.",
    points: [
      "Riparian forest corridor restoration along key riversystems",
      "Artificial nest box programs for cavity-nestingspecies",
      "Wetland hydrology rehabilitation in degradedfloodplains"
    ]
  },
  {
    title: "Policy & Legal Advocacy",
    text: "Field science means nothing if it doesn't translate into protection. Our policy team worksdirectly with governments to convert researchindings into enforceable law.",
    points: [
      "Fishing exclusion zone advocacy for penguincolonies",
      "Lead-free ammunition legislation campaigns",
      "CITES listing support for threatened species"
    ]
  },
  {
    title: "Captive Breeding & Release",
    text: "For species that have fallen below viable population thresholds, managed breeding programs buy time.convservationists partner with accredited facilities to individual release.",
    points: [
      "Southern Ground Hornbill release program in South Africa",
      "Bearded Vulture reintroduction in mountain regions",
      "Genetic diversity management across captive populations"
    ]
  },
  {
    title: "Public Education & Outreach",
    text: "People protect what they love, and they love what they know. Education work ranges from school programs to social media campaigns that reach audiences globally.",
    points: [
      "School conservation programs in 8 Africancountries",
      "Social media content reaching 500,000+ peopleannually",
      "Partnership with science journalists and documentary makers"
    ]
  }
];

const Solution = () => {
  return (
    <>
      {/* HERO */}

      <section
        className="position-relative"
        style={{
          height: "520px",
          backgroundImage: `url(${heroImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center"
        }}
      >
        <div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{
            background:
              "linear-gradient(rgba(0,0,0,.15), rgba(0,0,0,.75))"
          }}
        />

        <div className="container h-100 position-relative">
          <div className="row h-100 align-items-end">

            <div className="col-lg-7 text-white pb-5">

              <small
                className="text-uppercase"
                style={{
                  fontSize: "10px",
                  letterSpacing: "3px"
                }}
              >
                HOW BIRD CONSERVATION WORKS
              </small>

              <h1
                className="mt-3 mb-3"
                style={{
                  fontFamily: "Georgia, serif",
                  fontSize: "58px",
                  lineHeight: "1"
                }}
              >
                Solving an extinction
                <br />
                crisis requires more
                <br />
                than good intentions.
              </h1>

              <p
                style={{
                  maxWidth: "500px",
                  fontSize: "14px",
                  lineHeight: "1.8"
                }}
              >
                It requires rigorous science, genuine community relationships, and policy
                change that sticks. Here's how conservationists approach each layer of the problem.
              </p>

            </div>

          </div>
        </div>
      </section>

      {/* CARDS */}

      <section
        className="py-5"
        style={{
          background: "#f4f2ee"
        }}
      >
        <div
          className="container"
          style={{
            maxWidth: "1200px"
          }}
        >
          <div className="row g-4">

            {solutions.map((item, index) => (
              <div
                className="col-lg-4 col-md-6"
                key={index}
              >
                <div
                  className="h-100 p-4"
                  style={{
                    background: "#fff",
                    border: "1px solid #ececec",
                    minHeight: "330px"
                  }}
                >
                  <div
                    style={{
                      width: "28px",
                      height: "2px",
                      background: "#999",
                      marginBottom: "20px"
                    }}
                  />

                  <h5
                    className="mb-3"
                    style={{
                      fontFamily: "Georgia, serif"
                    }}
                  >
                    {item.title}
                  </h5>

                  <p
                    className="text-muted"
                    style={{
                      fontSize: "13px",
                      lineHeight: "1.8"
                    }}
                  >
                    {item.text}
                  </p>

                  <hr />

                  {item.points.map((point, i) => (
                    <div
                      key={i}
                      className="d-flex mb-2"
                    >
                      <span
                        className="me-2"
                        style={{
                          color: "#c98d2c"
                        }}
                      >
                        →
                      </span>

                      <small
                        style={{
                          color: "#666"
                        }}
                      >
                        {point}
                      </small>
                    </div>
                  ))}

                </div>
              </div>
            ))}

          </div>
        </div>
      </section>

      {/* CTA */}

      <section
        className="py-5 text-center text-white"
        style={{
          background: "#6d735d"
        }}
      >
        <div
          className="container"
          style={{
            maxWidth: "700px"
          }}
        >
          <h2
            className="mb-4"
            style={{
              fontFamily: "Georgia, serif",
              fontSize: "42px"
            }}
          >
            None of this work is free.
          </h2>

          <p
            className="mb-4"
            style={{
              color: "rgba(255,255,255,.85)",
              lineHeight: "1.8"
            }}
          >
            Field research, equipment, community programs,
            legal teams —
            convservationists appreciate your support.
          </p>

          
         <Link to="/donate" style={{ textDecoration: "none" }}>
                     <button
                       style={{
                         background: "#9b5d08",
                         color: "#fff",
                         border: "none",
                         padding: "12px 28px",
                         fontSize: "11px",
                         fontFamily: "'Helvetica Neue', Arial, sans-serif",
                         fontWeight: 700,
                         letterSpacing: "1.5px",
                         cursor: "pointer",
                       }}
                     >
                       SUPPORT THIS WORK →
                     </button>
                   </Link>

        </div>
      </section>
    </>
  );
};

export default Solution;